import React, {useEffect, useState} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import Box from '../../component/Box/Box'
import Page from '../../component/Page/Page'
import BreadcrumbItem from '../../component/BreadcrumbItem/BreadcrumbItem'
import {MobileApplicationsService} from "../../services/MobileApplicationsService";
import Notify from "../../services/Notify";
import {InputWithLabel} from "../../component/Form/InputWithLabel";
import Loading from "../../component/Loading/Loading";
import FormButtons from "../../component/Form/FormButtons";

function AlertsTriggerFormPage({history, match}) {

  const [isLoading, setIsLoading] = useState(null);
  const [entity, setEntity] = useState({});

  const mobileApplicationsService = new MobileApplicationsService()

  const save = async () => {
    try {
      setIsLoading(true)
      await mobileApplicationsService.save(entity);
      entity.id ? Notify.success('Dados do aplicativo atualizado!') : Notify.success('Aplicativo salvo!');
      history.goBack();
    } catch (error) {
      entity.id ? Notify.error('Erro ao atualizar dados do aplicativo', error) : Notify.error('Erro ao salvar o aplicativo', error)
    } finally {
      setIsLoading(false)
    }
  }
  const findOneById = async (id) => {
    try {
      setIsLoading(true);
      const newEntity = await mobileApplicationsService.getAppById(id);
      setEntity(newEntity);
    } catch (e) {
      Notify.error('Erro ao recuperar dados do aplicativo', e);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    if (match.params.id) {
      findOneById(match.params.id)
    }
  }, [match.params && match.params.id])
  const updateField = (field) => {
    setEntity({...entity, ...field});
  }

  return (
    <Page title="Dados do aplicativo" isLoading={isLoading}
          breadcrumbs={[<BreadcrumbItem title="Aplicativos" to="/dash/mobile-applications"/>]}>
      <Form
        className="pb-5 mt-5" onSubmit={e => e.preventDefault() || save()}
      >
        <Box>
          <Row>
            <Col md={4}>
              <InputWithLabel
                label="Nome"
                defaultValue={entity.friendlyName}
                onChange={e => updateField({friendlyName: e.target.value})}
                required={true}
              />
            </Col>
            <Col md={4}>
              <InputWithLabel
                label="Identificador"
                defaultValue={entity.identifier}
                onChange={e => updateField({identifier: e.target.value})}
              />
            </Col>
          </Row>
          <Row>
              <Col md={4}>
                <InputWithLabel
                  label="Versão android"
                  defaultValue={entity && entity.android && entity.android.currentVersion}
                  onChange={e => updateField({android: {currentVersion: e.target.value}})}
                />
              </Col>
              <Col md={4}>
                  <InputWithLabel
                    label="Versão ios"
                    defaultValue={entity && entity.ios && entity.ios.currentVersion}
                    onChange={e => updateField({ios: {currentVersion: e.target.value}})}
                  />
              </Col>
          </Row>
          {isLoading ? <Loading/> : <FormButtons history={history}/>}
        </Box>
      </Form>
    </Page>
  )
}
export default AlertsTriggerFormPage;



// WEBPACK FOOTER //
// ./src/pages/MobileApplications/MobileApplicationForm.js